import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { IInAppFeature } from '~/types/iap'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import DeleteActionCellRenderer from '~/components/CellRenderers/DeleteActionCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { badgeColDef } from '~/utils/table'

const columns: ColDef[] = [
  {
    cellRenderer: TextCellRenderer,
    headerName: 'Feature',
    minWidth: 100,
    suppressHeaderMenuButton: true,
    valueGetter: 'data.feature.feature_id',
  },
  badgeColDef(BadgeCellRenderer, {
    headerName: 'Group Features',
    headerTooltip: 'Group Features',
    valueGetter: ({ data }: ValueGetterParams<IInAppFeature>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { feature_groups } = data

      return {
        data: feature_groups.map((group) => ({ id: group.name, name: group.name })) || [],
        type: 'default',
      }
    },
  }),
  {
    cellRenderer: DeleteActionCellRenderer,
    field: 'actions',
    minWidth: 90,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: true,
    width: 90,
  },
]

export default columns
